import React, { PureComponent } from 'react'
import i18n from 'i18next'
import MergeFields from '../../../../utils/MergeFields'
import Switch from '../../../../UniformComponents/Switch'

class ReportPageTitle extends PureComponent {
    render() {
        const {
            reportStore,
            h2,
            h3,
            questionTypeCode,
        } = this.props
        return (
            <div className={`surveypage question ${questionTypeCode}`}>
                <h2 className="reportquestiontitle">
                    {reportStore.stripHtml(MergeFields.replace(h2, reportStore.locale, reportStore.mergeFields))}
                </h2>
                {h3 && (
                    <h3 className="reportquestiontitle">{reportStore.stripHtml(MergeFields.replace(h3, reportStore.locale, reportStore.mergeFields))}</h3>
                )}
                {
                    reportStore.branchComparisons.size
                        ? (
                            <Switch
                                label={(
                                    <span style={{ fontWeight: '700', color: '#2B3C44' }}>
                                        {i18n.t('report_toggleNestedBranches_label')}
                                    </span>
                                )}
                                onToggle={reportStore.toggleShowBranches}
                                state={reportStore.showBranches}
                                isLeft
                            />
                        )
                        : null
                }
            </div>
        )
    }
}

export default ReportPageTitle
